module.exports = __webpack_public_path__ + "img/subscription.f9789104.svg";